import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import Loader from 'components/Loader/Loader.component';
import { useEffect } from 'react';
import { authTokenKey } from 'services/session/session.config';
import { AuthType, setAuthType } from 'services/session/session.helpers';
import { clearCookie } from 'utils/functions/cookie';
import { z } from 'zod';

const authorizeSearchSchema = z.object({
  callbackurl: z.string().optional(),
  siteid: z.number().optional(),
});

export const Route = createFileRoute('/authorize')({
  component: Authorize,
  validateSearch: zodValidator(authorizeSearchSchema),
});

function Authorize() {
  const searchParams = Route.useSearch();

  const callbackurl = searchParams.callbackurl ?? '/private-area';
  const siteid = searchParams.siteid;

  useEffect(() => {
    const getAuthTokenViaPostMessage = (event: MessageEvent) => {
      const authToken = event.data.authToken;

      if (authToken == null) return;

      setAuthType(AuthType.Sso);
      clearCookie('JWT_ar');
      window.localStorage.setItem(authTokenKey, authToken);

      const url = new URL(callbackurl, window.location.origin);
      if (siteid != null) {
        url.searchParams.set('siteid', siteid.toString());
      }

      window.location.href = url.toString();
    };

    window.addEventListener('message', getAuthTokenViaPostMessage);
    window.postMessage({ operation: 'initial_login' }, '*');

    return () => {
      window.removeEventListener('message', getAuthTokenViaPostMessage);
    };
  }, [callbackurl, siteid]);

  return <Loader overlayViewMode="fullscreen" active={true} />;
}
